const resourceRoot = '/_ui/responsive/common/angular/assets';
const asmRoot = '/assisted-service';
const asmAutoCompleteUsers = `${asmRoot}/autocomplete`;
const mockRoot = `${resourceRoot}/mock`;
const searchAutoComplete =  '/search/autosuggest';
const clWizards =  '/v1/clwizards/';
const posesURL = '/poses';
const availabilityURL = '/v1/product/availability/';
const cartURL = '/cart';
const subscriptionsOrdersHistoryURL = '/my-account/subscriptions/history';
const listingURL = '/v1/products';
const productDetailsApiURL = '/newProductDetails';
const productDetailsAddToCartURL = '/cart/add';
const productDetailsAvailabilityURL = '/availability';
const productDetailsAddInsuranceURL = '/cart/bundleAdd'

export const ProductionLinks = {
  translation: `${resourceRoot}/translations/translations_{lang}_{country}.json`,
  customer: {
    searchByNameOrEmail: `${asmAutoCompleteUsers}`
  },
  searchBox: {
    response: `${searchAutoComplete}`
  },
  clWizards: {
    response: `${clWizards}`
  },
  poses: {
    response: posesURL,
    towns: `${posesURL}/towns`,
    town: `${posesURL}/town/`,
    posesAll: `${posesURL}/all`
  },
  availability: {
    response: availabilityURL
  },
  cart: {
    response: `${cartURL}/deliveryModes`,
    deliveryDPD: `${cartURL}/delivery/dpd/`,
    deliveryPharmaLink: `${cartURL}/delivery/pharmalink`,
    deliveryEmail: `${cartURL}/delivery/email`,
    deliveryInpost: `${cartURL}/delivery/inpost`,
    deliveryPickup: `${cartURL}/delivery/pickup?posName=`,
    deliveryPost: `${cartURL}/delivery/postPickup/`,
    deliveryDPDPickup: `${cartURL}/delivery/dpdPickup?pointID=`,
    paymentMode: `${cartURL}/paymentMode/`,
    clear: `${cartURL}/delivery/clear`
  },
  asm: {
    logout: `${asmRoot}/logoutasm`
  },
  subscriptions: {
    ordersHistory: subscriptionsOrdersHistoryURL
  },
  listing: {
    response: listingURL
  },
  productDetails: {
    apiURL: `${productDetailsApiURL}`,
    addToCartURL: `${productDetailsAddToCartURL}`,
    availabilityURL: `${productDetailsAvailabilityURL}`,
    addInsuranceURL: `${productDetailsAddInsuranceURL}`
  }
};
